import TicketingTransactionsScreen from './TicketingTransactionsScreen';

export default TicketingTransactionsScreen;
